import{useRef,useEffect}from"react";const useRunOnce=(fn,enabled=!0)=>{const triggeredRef=useRef(!1);useEffect(()=>{!enabled||triggeredRef.current||(fn(),triggeredRef.current=!0)},[enabled,fn])};export{useRunOnce};
